import api from './axios';

const ElectionService = {
  getElections: () => api.get('/api/v1/elections'),
  getElection: (id) => api.get(`/api/v1/elections/${id}`),
  createElection: (data) => api.post('/api/v1/elections', data),
  updateElection: (id, data) => api.put(`/api/v1/elections/${id}`, data),
  deleteElection: (id) => api.delete(`/api/v1/elections/${id}`),
  castVote: (electionId, candidateId) => api.post(`/api/v1/elections/${electionId}/cast-vote`, { candidate_id: candidateId }),
};

export default ElectionService;
